import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

StripDevider.propTypes = {
  sx: PropTypes.object
};

export default function StripDevider({ sx }) {
  return (
    <Box sx={{ textAlign: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="262" height="1" viewBox="0 0 262 1" fill="none">
        <line y1="0.5" x2="262" y2="0.5" stroke="url(#paint0_linear_15_84)" />
        <defs>
          <linearGradient id="paint0_linear_15_84" x1="0" y1="1.5" x2="262" y2="1.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3E3E44" />
            <stop offset="0.505" stopColor="#68686D" />
            <stop offset="1" stopColor="#3E3E44" />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
}
